module.exports = __webpack_public_path__ + "img/Bathroom-Aerator.4a2fae3c.svg";